/* eslint-disable */

import Vue from 'vue';
import VueI18n from 'vue-i18n';

import en from './languages/en.json';
import hu from './languages/hu.json';

Vue.use(VueI18n);

const locale = 'hu';

const messages = {
    en,
    hu
};

const i18n = new VueI18n({
    locale,
    messages,
});
/*
const userLang = navigator.language || navigator.userLanguage;
if (userLang.split('-')[0] === 'hu') {
    i18n.locale = 'hu';
} else {
    i18n.locale = 'en';
}*/
// Set english to default language
i18n.locale = 'en';
export default i18n;
